export default __webpack_public_path__ + "ce56675fe640fd0c6a06dea9364d49b4.svg";